<form #form novalidate (ngSubmit)="steps.includes(numberSteps) ? checkChannelsLimitations() : continue()">
  <!-- TODO: Uncomment this when we use me/permissions  -->
  <!-- <div id="messageDetailContainer"
    class="container absolute top-20 right-0 hiddenDetails w-0 h-[calc(100vh-75px)] overflow-hidden flex flex-col"
    [ngClass]="{ 'openDetails': message && !edit && roleService.permissions['USER']['READ'], 'openDetailsEdit': message && edit && roleService.permissions['USER']['UPDATE'], 'expandedDetails': expanded}"> -->
  <div id="messagesDetailContainer" class="container absolute top-20 right-0 hiddenDetails w-0 h-[calc(100vh-75px)] overflow-hidden flex flex-col"
  [ngClass]="{ 'openDetails': message() || newMessage()}">
    <section class="bg-primary-purple-light-2 h-14 mt-4 flex items-center">
      <div class="mr-4 my-2 ml-6 justify-end ">
        <div class="flex main rounded-[50%] h-10 w-10 justify-center items-center"
          [ngClass]="{'hidden': !newMessage()}">
          <div [ngClass]="{ 'block': steps.includes(1), 'hidden': !steps.includes(1), 'quarter1': numberSteps === 3, 'half1': numberSteps === 2 }"></div>
          <div [ngClass]="{ 'block': steps.includes(2), 'hidden': !steps.includes(2), 'quarter2': numberSteps === 3, 'half2': numberSteps === 2 }"></div>
          <div class="quarter3" [ngClass]="{ 'block': steps.includes(3), 'hidden': !steps.includes(3) }"></div>
          <label class="flex font-bold text-base text-primary-purple cutout justify-center items-center">
            {{ currentStep }}/{{ numberSteps }}
          </label>
        </div>
      </div>
      <h1 class="ml-2 text-xl font-semibold text-primary-purple">
        {{ literalService.get(`messages.${newMessage() ? 'new' : 'message'}`, true) }}
      </h1>
      <section id="actions" class="flex ml-auto mr-8">
        <div class="flex items-center justify-center gap-2">
          @if (!newMessage() && message(); as selectedMessage) {
            <app-message-redirect-button [message]="selectedMessage" />
          }
          <img [src]="images.close" alt="closeDetails" class="h-6 w-6 cursor-pointer" (click)="close()" [tooltip]="literalService.get('closeWindow', true)" [position]="TooltipPosition.BELOW" />
        </div>
      </section>
    </section>
    <section class="h-full !p-8 flex flex-col justify-between overflow-auto scrollable-content">
      <article id="body" class="pb-6">
        <div class="grid grid-rows-8 grid-flow-col gap-x-10" [ngClass]="{'!grid-rows-5': newMessage() && currentStep < numberSteps, '!grid-rows-9':  newMessage() && currentStep === numberSteps && message()?.receiver === MessageReceiver.EXPEDITION}">
          @for (element of messageForm; track element.id; ) {
            @if ((!newMessage() || !element.edit?.editable)) {
              <div class="mt-4"
                [ngClass]="{'hidden': element.hidden, 'row-span-2': element.edit && element.edit.inputType === InputType.LONG_TEXT && element.value.length >= 100 }">
                <app-detail
                  [data]="element"
                  [value]="element.value"
                  [extendable]="element.edit && element.edit.inputType === InputType.LONG_TEXT && element.value.length >= 100" />
              </div>
            }
            @else if (newMessage()) {
              <div class="mt-2 h-full" [ngClass]="{'row-span-2': element.edit.inputType === InputType.LONG_TEXT, 'hidden': element.hidden}">
                <app-input
                  [data]="element"
                  [edit]="true"
                  [independent]="false"
                  [translateValue]="element.edit?.translateValue"
                  [hasErrors]="invalid.includes(element.edit?.valueToChange)"
                  [error]="showError(element.value, element.edit?.valueToChange)"
                  (setEventEmitter)="changeData($event.value, element)"
                  (changeEventEmitter)="changeData($event.target, element)"
                  (scrollEventEmitter)="scroll($event, element.edit?.valueToChange)"
                  (searchEventEmitter)="search($event, element.edit?.valueToChange)"
                />
              </div>
            }
          }
        </div>
        @if (!newMessage() && message()?.dateTime) {
          <div class="flex flex-row justify-end items-center gap-2 mt-6">
            <img [src]="images.user.changelog" alt="" aria-hidden="true" class="h-5 w-5 filter-primary-purple-light" />
            <p class="changelog text-primary-purple-light font-light text-sm text-right">
              {{ literalService.get('messages.tooltips.sent', true) }} {{ literalService.get('at') }}
              <time [attr.datetime]="sentDate() | date: 'yyyy-MM-ddTHH:mm'">{{ sentDate() | date: 'dd/MM/yyyy HH:mm' }}</time>
            </p>
          </div>
        }
      </article>
      @if (newMessage()) {
        <app-form-actions
          [cancelLabel]="currentStep === 1 ? 'cancel' : 'back'"
          [saveLabel]="steps.includes(numberSteps) ? 'messages.send' : 'continue'"
          [saveDisabled]="disabledSaveButton()"
          (cancelAction)="currentStep === 1 ? cancel() : goBack()"
          (saveAction)="steps.includes(numberSteps) ? checkChannelsLimitations() : continue()"
        />
      }
    </section>
  </div>
</form>
<app-modal-confirmation
  [id]="'exceedReceiversModal'"
  [modal]="exceedReceiversModal"
  [shown]="exceedReceiversModalShowed"
  [icon]="images.messages.alert"
  [title]="'messages.modal.exceedReceivers.title'"
  [text]="exceedReceiversText"
  [sameLineButtons]="true"
  [centerText]="true"
  [confirmText]="'messages.modal.exceedReceivers.confirm'"
  [cancelText]="'messages.modal.exceedReceivers.cancel'"
  [confirmStyle]="'secondary'"
  [cancelStyle]="'primary'"
  (cancelAction)="close()"
  (action)="checkAdditionalCost()"
></app-modal-confirmation>
<app-modal-confirmation
  [id]="'additionalCostModal'"
  [modal]="additionalCostModal"
  [shown]="additionalCostModalShowed"
  [icon]="images.messages.alert"
  [title]="'messages.modal.additionalCost.title'"
  [text]="'messages.modal.additionalCost.description'"
  [sameLineButtons]="true"
  [centerText]="true"
  [confirmText]="'messages.modal.additionalCost.confirm'"
  [cancelText]="'messages.modal.additionalCost.cancel'"
  (cancelAction)="close()"
  (action)="onSubmit()"
></app-modal-confirmation>